/* global jQuery Swiper initMap tgInit */

; (function ($) {
	$(document).ready(function () {
		// runs for first page load
		init()
	})

	function init() {
		/**
		 * Run initialition for core functionality
		 */
		coreInit()

		/**
		 * run initialisation for external scripts
		 */
	
		//initMap()
		//gridSlider()
	}

	function coreInit() {
		// helps us detect touchscreen-based browsers
		window.isTouch = false
		$(window).one('touchstart', function onFirstTouch() {
			window.isTouch = true
			$('body').addClass('is-touch')
		})

		setScrollbar()

		/**
		 * General/global
		 */
		$('[input-select-all]').on('focus click', function () {
			setTimeout(() => {
				this.focus()
				this.setSelectionRange(0, 99999)
				this.select()
			}, 50)
		})

		/**
		 * navigation
		 */
		// mobile nav toggle
		$('#nav-toggle').click(function () {
			$('#site-navigation').toggleClass('toggled')
			$('#nav-toggle').toggleClass('toggled')
			$('body').toggleClass('is-no-scroll')
			$('#primary-menu .menu-item-has-children>a').removeClass('active').next().slideUp(200)
			$(this).attr(
				'aria-expanded',
				$(this).attr('aria-expanded') === 'false'
			)
		})
		// if mobile nav or if touchscreen, menu items with children can not be followed
		$('#primary-menu .menu-item-has-children>a').click(function (e) {
			if ($(window).width() < 996 || window.isTouch) {
				e.preventDefault()
				e.stopPropagation()
			}
		})
		// mobile menu sub-menu handling
		$('#primary-menu .menu-item-has-children>a').click(function (e) {
			if ($('#site-navigation').hasClass('toggled')) {
				console.log($(this).html());
				e.preventDefault()
				let dir = $(this).parent().attr('aria-expanded') === 'true'
				if (dir) {
					$(this).next().slideUp(200)
					$(this).parent().attr('aria-expanded', 'false')
				} else {
					$(this).next().slideDown(200)
					$(this).parent().attr('aria-expanded', 'true')
				}
			}
		})
		// when mobile menu open a click to anything else closes it
		$(document).click(function (event) {
			if (!$(event.target).closest('#site-navigation .site-mask, #nav-toggle').length && $('#site-navigation').hasClass('toggled')) {
				$('#site-navigation').removeClass('toggled')
				$('#nav-toggle').removeClass('toggled')
				$('body').removeClass('is-no-scroll')
			}
		})
		// mobile home nav background
		if ($('body').hasClass('home')) {
			navBg()
			$(document).on('scroll.headerbg', throttle(function () {
				navBg()
			}, 50))
			$(document).on('resize.headerbg', throttle(function () {
				navBg()
			}, 50))
		}
		function navBg() {
			if ($(window).width() < 996) {
				let opacity = $(window).scrollTop() / 400
				$('#header .header-bg').css('opacity', opacity > 0.85 ? 0.85 : opacity)
			} else {
				$('#header .header-bg').css('opacity', '')
			}
		}

		/**
		 * page head — carousel
		 */
		if ($('.app-pageHead__slide', '.app-pageHead__slider').length > 1) {
			new Swiper('.app-pageHead__slider', {
				autoplay: {
					delay: 7000
				},
				loop: true,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					bulletElement: 'button',
					clickable: true
				}
			})
		}

		/**
		 * testimonials
		 */
		new Swiper('.app-testimonials .swiper-container', {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 30,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			autoplay: {
				delay: 5000,
			},
			breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        }      
      },
		})


		/**
		 * logo slider
		 */
		const progressCircle = document.querySelector(".autoplay-progress svg");
    const progressContent = document.querySelector(".autoplay-progress span");
   
		new Swiper('.title-swiper-container', {
			loop: true,
			direction: "vertical",
			slidesPerView: 1,
		
			watchSlidesVisibility: true,
			autoplay: {
				delay: 5000,
			}			
		})


	
		/**
		 * skip link
		 */
		$('.skip-link').click(function (event) {
			event.preventDefault();
			var skipto = $(this).data('skipto');
			if (skipto) {
				var skipPage = $('html, body');

				skipPage.on('mousedown wheel DOMMouseScroll mousewheel touchmove', function () {
					skipPage.stop();
				});

				skipPage.animate({
					scrollTop: $(skipto).offset().top - $('#header').height()
				}, 1000, function () {
					skipPage.off('mousedown wheel DOMMouseScroll mousewheel touchmove')
				})
			}
		});


		/**
		 * footer
		 */
		// mobile footer 'accordion' on mobile
		$('.footer-accordion-button').click(function () {
			if ($(window).width() < 996) {
				$(this)
					.closest('.accordion')
					.toggleClass('shown')
			}
		})


	}

	function gridSlider() {
		if ($('.app-gridSlider').length) {
			let rows = 2
			if ($(window).width() < 768) {
				rows = 1
			}
			$('.app-gridSlider .tg-layout-grid').data('row', rows)
			tgInit()

			const rightArrow = $('.app-gridSlider__arrow.tg-right-arrow')
			rightArrow.before(rightArrow.next())

			const MutationObserver = window.MutationObserver || window.WebKitMutationObserver
			const observer = new MutationObserver(throttle(gridSliderMutation, 300))
			const obsConfig = {
				attributeFilter: ['style'],
				attributes: true,
				characterData: false,
				subtree: false
			}

			$('.app-gridSlider .tg-layout-grid').each(function () {
				observer.observe(this, obsConfig)
			})
		}
	}

	function gridSliderMutation(mutationRecords) {
		$.each(mutationRecords, function (i, mutation) {
			const $gridSlider = $(mutation.target)
			const width = $gridSlider.parent().outerWidth()

			const transform = $gridSlider.css('transform')
			let matrixIndex
			if (transform.substring(0, 8) === 'matrix3d') {
				matrixIndex = 13
			} else {
				matrixIndex = 4
			}
			const transformX = parseFloat(transform.match(/-?[\d.]+/g)[matrixIndex])

			$gridSlider.children().each(function () {
				const left = parseFloat($(this).css('left'))
				const center = left + ($(this).outerWidth() / 2)
				const offset = center + transformX

				if (offset > -10 && offset < width + 10) {
					$(this).addClass('tg-item-active')
				} else {
					$(this).removeClass('tg-item-active')
				}
			})
		})
	}

	function animateOut() {
		// hide nav
		$('#site-navigation').removeClass('toggled')
		$('#nav-toggle').removeClass('toggled')
	}

	function unload() {
		// close any open fancybox instances
		$.fancybox.close()

		// header bg fade in
		$(document).off('scroll.headerbg')
		$(document).off('resize.headerbg')

		// footer
		$('.footer-accordion-button').off('click')
	}

	// set scrollbar
	function setScrollbar() {
		var body = document.querySelector('body')
		if (window.innerWidth > body.clientWidth + 5) {
			$('body').removeClass('no-scrollbar')
			document.documentElement.style.setProperty(
				'--scrollbar-width',
				window.innerWidth - body.clientWidth + 'px'
			)
		} else {
			$('body').addClass('no-scrollbar')
		}
	}

	// on scroll
	$(window).scroll(function () {
		scrolling(this)
	});

	// on resize
	$(window).on('resize', function () {
		scrolling(this)
		$('body').removeClass('js-menu-mobile-active')
	});

	// scrolling function
	let stickyPoint = 150;

	function scrolling(el) {
		let scroll = $(el).scrollTop()
		// if header out of view, prep it off canvas for being sticky
		if (scroll > stickyPoint) {
			$('#header').addClass('js-sticky')
		} else {
			$('#header').removeClass('js-sticky')
		}

		// when past sticky point, bring in header
		if (scroll > stickyPoint && !$('#header').hasClass('js-on')) {
			$('#header').addClass('js-on')
		} else if (scroll < stickyPoint && $('#header').hasClass('js-on')) {
			$('#header').removeClass('js-on')
		}
	}

	function throttle(func, wait, options) {
		var context, args, result
		var timeout = null
		var previous = 0
		if (!options) options = {}
		var later = function () {
			previous = options.leading === false ? 0 : Date.now()
			timeout = null
			result = func.apply(context, args)
			if (!timeout) context = args = null
		}
		return function () {
			var now = Date.now()
			if (!previous && options.leading === false) previous = now
			var remaining = wait - (now - previous)
			context = this
			args = arguments
			if (remaining <= 0 || remaining > wait) {
				if (timeout) {
					clearTimeout(timeout)
					timeout = null
				}
				previous = now
				result = func.apply(context, args)
				if (!timeout) context = args = null
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining)
			}
			return result
		}
	}

	// Create the observer like the examples above
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('content-animation');
				return;
			}
		});
	});

	// Get multiple elements instead of a single one using "querySelectorAll"
	const content_animate = document.querySelectorAll('.content-animate');

	// Loop over the elements and add each one to the observer
	content_animate.forEach((element) => observer.observe(element));

	

	

})(jQuery);
